@if (permDir.uipermission() !== PERMISSIONS.NONE || permDir.editPermissions()) {
  <!--#region Label Top -->

  @if (settings().labelPosition === 'top') {
    <ng-container *ngTemplateOutlet="uiLabelTemplateRef"></ng-container>
  }
  <ng-content select="label[slot-top]"></ng-content>

  <!--#endregion Label Top -->

  <div uiinputcontent (click)="toggleOptionsPopup()">
    <!--#region Default Icon Left -->

    @if (settings().defaultIconSlot === 'left') {
      <ng-container *ngTemplateOutlet="uiDefaultIconTemplateRef"></ng-container>
    }
    <ng-content select="icon[slot-left]"></ng-content>

    <!--#endregion Default Icon Left -->

    <!--#region Label Embedded -->

    @if (settings().labelPosition === 'embedded') {
      <ng-container *ngTemplateOutlet="uiLabelTemplateRef"></ng-container>
    }
    <ng-content select="label[slot-embedded]"></ng-content>

    <!--#endregion Label Embedded -->

    <!--#region Input -->

    <div
      uichipstrip
      readonly
      class="overflow-hidden"
      [class]="inputCssClass()!"
      [ngClass]="{
        'flex-nowrap': settings().shrinkCount,
        'flex-wrap': !settings().shrinkCount,
      }"
      #uiValueRef
      uivalue
      (click)="toggleOptionsPopup()"
    >
      @if (!selectedDates().length) {
        <span uiplaceholder>{{ this.settings().placeholder }}</span>
      }
      @for (
        selectedDate of selectedDates().slice(
          0,
          settings().shrinkCount && settings().shrinkCount! > 0
            ? settings().shrinkCount
            : selectedDates().length
        );
        track $index
      ) {
        <chip
          [settings]="{
            label: (selectedDate | date: format()) || '',
            disabled: this.disabled(),
          }"
        >
          <icon
            right
            [iconDefinition]="ICONS.CLOSE"
            (click)="
              updateDateCollection(selectedDate);
              $event.stopImmediatePropagation()
            "
          ></icon>
        </chip>
      }
    </div>

    <!--#endregion Input -->

    <!--#region Tools -->

    <div uitoolstrip [class]="toolstripCssClass()">
      <ng-container #uiToolsDefaultRef>
        @if (
          settings().showClearButton && !isNil(value()) && !settings().disabled
        ) {
          <btn
            uihovertool
            uicleartool
            uiunpermissioned
            class="unstyled xxs"
            [settings]="{
              icon: ICONS.CLOSE_SMALL,
              iconOnly: true,
            }"
            (click)="
              updateValue(undefined);
              selectedDates.set([]);
              $event.stopImmediatePropagation()
            "
          >
          </btn>
        }
      </ng-container>
      <ng-content #uiToolsMarkupRef select="[uitool]"></ng-content>
      <ng-template #uiToolsCodeRef></ng-template>
    </div>

    <!--#endregion Tools -->

    <!--#region Default Icon Right -->

    @if (settings().defaultIconSlot === 'right') {
      <ng-container *ngTemplateOutlet="uiDefaultIconTemplateRef"></ng-container>
    }
    <ng-content select="icon[slot-right]"></ng-content>

    <!--#endregion Default Icon Right -->

    <!--#region Selection Options -->

    @if (permDir.uipermission() !== PERMISSIONS.VIEW) {
      <ul
        class="fit"
        #uiPopupRef
        [class]="popupCssClass()"
        [UiPopup]="popupSettings()"
        (UiPopupVisibilityChanged)="popupChanged($event)"
      >
        @if (showCalendarNav() || showCalendarPrev() || showCalendarNext()) {
          <li uipopupheader>
            @if (showCalendarPrev()) {
              <btn
                uiunpermissioned
                class="tertiary xxs"
                [settings]="{ icon: ICONS.CHEVRON_LEFT, iconOnly: true }"
                [inputCssClass]="'shadow-none'"
                (click)="scroll(-1)"
              ></btn>
            }
            @if (showCalendarNav()) {
              <btn
                uiunpermissioned
                class="tertiary xxs"
                [settings]="{ label: calendarTitle()! }"
                [inputCssClass]="'shadow-none'"
                (click)="selectCalendarContent()"
              ></btn>
            }
            @if (showCalendarNext()) {
              <btn
                uiunpermissioned
                class="tertiary xxs"
                [settings]="{ icon: ICONS.CHEVRON_RIGHT, iconOnly: true }"
                [inputCssClass]="'shadow-none'"
                (click)="scroll(1)"
              ></btn>
            }
          </li>
        }
        @for (option of options(); track i; let i = $index) {
          <li
            tabindex="0"
            [attr.uilog]="option.label"
            [attr.uipopupoption]="uid()"
            [attr.uipopupoptiondisabled]="!option.isSelectable || undefined"
            [attr.uipopupoptionselected]="option.isSelected"
            [attr.uipopupoptionindicated]="option.isIndicated"
            (click)="option.isSelectable ? select(option, $event) : false"
          >
            {{ option.label }}
          </li>
        }
      </ul>
    }

    <!--#endregion Selection Options -->
  </div>

  <!--#region Footer -->

  @switch (state()) {
    @case ('error') {
      <span
        uifooter
        uistate="error"
        class="cursor-help"
        [title]="errors().join('\r\n')"
        >{{
          errors().length > 1
            ? errors().at(0) +
              ' (' +
              (errors().length - 1).toString() +
              ' more)'
            : errors().at(0)
        }}</span
      >
    }
    @case ('warning') {
      <span
        uifooter
        uistate="warning"
        class="cursor-help"
        [title]="warnings().join('\r\n')"
        >{{
          warnings().length > 1
            ? warnings().at(0) +
              ' (' +
              (warnings().length - 1).toString() +
              ' more)'
            : warnings().at(0)
        }}</span
      >
    }
  }

  <!--#endregion Footer  -->

  <!--#region Templates -->

  <!-- Label Template -->
  <ng-template #uiLabelTemplateRef>
    <label
      uipopuptrigger
      [class.hidden]="!settings().label && !settings().labelTip"
      [attr.slot-embedded]="
        settings().labelPosition === 'embedded' ? true : undefined
      "
      [label]="labelFormatted()"
      [labelTip]="labelTip()"
      [state]="state()"
    >
    </label>
  </ng-template>

  <!-- Default Icon Template-->
  <ng-template #uiDefaultIconTemplateRef>
    @if (!settings().hideDefaultIcon) {
      <icon
        [attr.uidefaulticon]="settings().defaultIconSlot"
        [iconDefinition]="defaultIcon()"
        [iconCssClass]="'fill-none'"
        (click)="toggleOptionsPopup()"
      ></icon>
    }
  </ng-template>

  <!--#endregion Templates -->
}
